<template lang="pug">
  .sign-enrollment-docs
    v-scroll-y-transition(leave-absolute)
      v-skeleton-loader(
        v-if="loadingStatements"
        type="card@2"
      )
    template(v-if="!loadingStatements")
      .d-flex.align-center.mb-5(v-if="statements.length")
        v-avatar(color="secondary")
          v-icon(color="white") mdi-file-sign
        .ml-3
          .title Подпись документов
          .caption Пожалуйста, скачайте подпишите и загрузите необходимые документы
      v-card(
        v-for="(item, idx) in statements"
        :key="idx"
        color="secondary"
        dark
      ).sdo-card.my-10
        v-card-text.d-flex.align-center
          .my-4
            .title.white--text {{ item.name }}
            .description {{ item.description }}
          v-spacer
          file-upload(
            ref="fileUploader"
            name="Файл"
            hide-input
            @file:changed="addFile(idx)"
          )
          v-btn(
            text
            large
            fab
            :href="`data:application/pdf;base64,${item.pdf}`"
            download
          )
            v-icon mdi-download
        v-btn(
          v-if="item.scan_file_url"
          depressed
          text
          color="success"
          :href="item.scan_file_url"
          target="_blank"
        ).mx-n2.py-6
          v-icon(color="success") mdi-paperclip-check
          span.white--text.ml-4 Подписанное заявление
        v-btn(
          depressed
          color="secondary lighten-1"
          :loading="loading.upload[idx]"
          @click="selectFile(idx)"
        ).mx-n2.py-6
          v-icon(color="white") mdi-file-document-outline
          span.white--text.ml-4 Загрузить подписанное заявление
</template>

<script>
import FileUpload from '@/components/InputFields/FileUpload.vue';

export default {
  components: {
    FileUpload,
  },
  props: {
    statements: { type: Array, required: true },
    loadingStatements: { type: Boolean, default: false },
  },
  data: () => ({
    loading: {
      upload: {},
    },
  }),
  methods: {
    selectFile(idx) {
      this.$refs.fileUploader[idx].pickfile();
    },
    async addFile(idx) {
      this.$set(this.loading.upload, idx, true);
      try {
        const file = await this.$refs.fileUploader[idx].uploadFile();
        this.$emit('uploaded', { statement: this.statements[idx], file });
      } catch (e) {
        console.log(e);
      }
      this.$set(this.loading.upload, idx, false);
    },
  },
};
</script>
